import WarehouseRentList from './warehouse_rent_list'
import connect from './connect'

export default connect(WarehouseRentList)
